"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const typeorm_2 = require("@nestjs/typeorm");
const acl_category_action_api_map_entity_1 = require("./entities/acl-category-action-api-map.entity");
const acl_category_action_map_entity_1 = require("./entities/acl-category-action-map.entity");
const role_acl_category_action_map_entity_1 = require("./entities/role-acl-category-action-map.entity");
let AclService = class AclService {
    constructor(aclCategoryActionApiMapRepository) {
        this.aclCategoryActionApiMapRepository = aclCategoryActionApiMapRepository;
    }
    async hasAccess(roleIds, method, path) {
        try {
            let result = await this.aclCategoryActionApiMapRepository.createQueryBuilder("aclCategoryActionApiMap")
                .innerJoin(acl_category_action_map_entity_1.AclCategoryActionMap, "aclCategoryActionMap", "aclCategoryActionApiMap.acl_category_action_id = aclCategoryActionMap.id")
                .innerJoin(role_acl_category_action_map_entity_1.RoleAclCategoryActionMap, "roleAclCategoryActionMap", "aclCategoryActionMap.id = roleAclCategoryActionMap.acl_category_action_id")
                .where("roleAclCategoryActionMap.role_id IN (:...roleIds)", { roleIds })
                .andWhere("aclCategoryActionApiMap.method = :method", { method })
                .andWhere("aclCategoryActionApiMap.api = :path", { path })
                .getMany();
            return result.length > 0;
        }
        catch (error) {
            console.error("Error checking access:", error);
            return false;
        }
    }
};
exports.AclService = AclService;
exports.AclService = AclService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_2.InjectRepository)(acl_category_action_api_map_entity_1.AclCategoryActionApiMap)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _a : Object])
], AclService);
